"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var BaseModel = require("../../common/models/base-model");
var PageModel = require("./page-model");
var PageList = require("../lib//page-list");

var debug = require("debug")("models:DocumentModel");    //https://github.com/visionmedia/debug


/**
 * DocumentModel
 */

module.exports = BaseModel.extend({

    pv5api: null,
    useTokenCookie: false, // utilisation du token passé par cookie pour les appels aux pages et images

    defaults: {
        nbPages: 0,          // nombre de pages du pdf
        publicationId: 0,    // identifiant de publication dans pv5
        publicationTitle: null,
        published: null,     // release date
        title: null,         // document title
        isDouble: false,     // double or simple page production
        pages: null,         // page models collection
        page: 0,             // current page number (left page if double)
        isTextMissing: false,// text of document available
        isXml: false,        // xml description available
        toc: 0,              // toc pdf page
        logisticId: null,           // identifiant du logisticien
        documentLogisticId: 0,      // identifiant du document chez le logisticien ci-dessus
        publicationLogisticId: 0,   // identifiant de la publication chez le logisticien ci-dessus
        mtime: 0,            // timestamp de modification du zpa (ajouté à la volée par le serveur)
        reversed: false,     // sens de lecture inversé
        hasToc: false,        // toc.json disponible dans le xml
        hasLayout: false,      // layout.json disponible dans xml
        hasPDF: false,        // pdf available
        lang: null,
        pdfDocument: null, // document pdf chargé par la lib pdfjs https://mozilla.github.io/pdf.js/api/draft/module-pdfjsLib-PDFDocumentProxy.html
        serverPdfMaxPages: 100, // nombre de pages limite par pdf généré pour l'impression
        pageList: null, // tableau de correspondance page num / page label
        displayTitle: null // nom d'affichage du document, remplace pub title / doc title / release date dans le reader par exemple
    },

    urlRoot: function () {
        return this.pv5api + "/document/" + this.get("publicationId");
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);

        var T = this;
        debug("initialize");
        _.extend(T, options);

        if (T.useTokenCookie) {
            T.withCredentials = true;
        }

        this.set({
            "pages": new Backbone.Collection()
        });
    },

    /**
     * get page model from collection, fetch it if not already done
     * @param  {Number} page
     * @return {PageModel}
     */
    getPageModel: function (page) {
        // get page from collection and fetch if necessary
        var T = this;

        if (!page || page < 1 || page > T.get("nbPages")) {
            return;
        }

        var page_model = T.get("pages").get(page);

        if (!page_model) {
            var page_options = {
                pv5api: T.pv5api,
                isDocumentDouble: T.get("isDouble"),
                mtime: T.get("mtime")
            };
            if (T.token) {
                if (T.useTokenCookie) {
                    page_options.withCredentials = true; // pour que ça soit le token du cookie qui soit utilisé
                }
                else {
                    page_options.token = T.token; // pour que le token se retrouve dans l'url
                }
            }
            page_model = new PageModel(
                {
                    id: page,
                    publicationId: T.get("publicationId"),
                    documentId: T.get("id")
                },
                page_options
            );
            T.get("pages").add(page_model);
            page_model.fetch();
        }

        return page_model;
    },

    thumbnailUrl: function (page) {
        var T = this;
        return T.pageUrl(page) + "/thumbnail";
    },

    pageUrl: function (page) {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/page/" + page;
    },

    pdfUrl: function () {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/vecto";
    },

    pageLabelFromNumber: function (page) {
        var page_label, page_number;
        var page_list = this.get("pageList");
        if (page_list) {
            page_number = Number(page);
            page_label = page_list[page_number - 1];
        }
        else {
            page_label = page;
        }
        return page_label;
    },

    pageNumberFromLabel: function (page_label){
        return this.get("pageList").indexOf(page_label) + 1;
    },

    convertPrintRangeLabel: function(page_str){
        var final_page_str = "";
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                if(final_page_str.length){
                    final_page_str += ","
                }
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if(page_interval_spl.length == 1){
                    final_page_str += this.pageNumberFromLabel(page_interval_spl[0].trim())
                }
                else if(page_interval_spl.length == 2){
                    final_page_str += this.pageNumberFromLabel(page_interval_spl[0].trim()) + "-" + this.pageNumberFromLabel(page_interval_spl[1].trim());
                }
            }
        }
        return final_page_str;
    },

    parse: function (data) {
        if (data.pageList) {
            data.pageList = PageList.uncompress(data.pageList);
        }
        return data;
    }

});



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/models/document-model.js
// module id = 38
// module chunks = 0